import * as sentry from '../../src/utils/sentry'
import { strictParseInt } from '../../../shared/lib/number.no-deps'
import { DS_setData } from '../DS/DS.Data'

export const LS_version = 7 // Change this comment to avoid collisions: dscisdnifj

export function LS_migrate() {
    // If this fresh install, or the user is logged out, there is nothing to migrate
    // However, even in these cases there are possibly still 2 entries in localStorage
    // These are caused by the debug library putting it config settings in here.
    // Hence this check is asking if localStorage is empty, after taking them into accoUnit.
    if (localStorage.length < 5) {
        localStorage.setItem('lStorageVersion', LS_version.toString())
        return
    }

    // Get the previous lStorageVersion
    const oldVersionStr = localStorage.getItem('lStorageVersion')
    const oldVersion = strictParseInt(oldVersionStr) || 0

    // Run migrations

    if (oldVersion < 1) {
        try {
            const user = JSON.parse(localStorage.getItem('user'))
            const connectionAddress = JSON.parse(localStorage.getItem('hive.connectionAddress'))

            const customer = {
                id: user.customer.id,
                name: user.customer.name,
                domainName: connectionAddress,
            }

            delete user.customer

            localStorage.setItem('customer', JSON.stringify(customer))
            localStorage.setItem('user', JSON.stringify(user))
        } catch (error) {
            sentry.err(error, {})
        }
    }

    if (oldVersion < 2) {
        // Migrate hive.connectionAddress to customer if customer lost due to bug
        try {
            const user = JSON.parse(localStorage.getItem('user'))
            const connectionAddress = JSON.parse(localStorage.getItem('hive.connectionAddress'))
            const customer = JSON.parse(localStorage.getItem('customer'))

            if (user && !customer) {
                localStorage.setItem(
                    'customer',
                    JSON.stringify({
                        id: -1,
                        name: '',
                        domainName: connectionAddress,
                    })
                )
            }
        } catch (error) {
            sentry.err(error, {})
        }
    }

    if (oldVersion < 3) {
        // Remove routing from user
        try {
            const user = JSON.parse(localStorage.getItem('user'))
            delete user.routing
            localStorage.setItem('user', JSON.stringify(user))
        } catch (error) {
            sentry.err(error, {})
        }
    }

    if (oldVersion < 4) {
        // Migrate user for single sign on
        try {
            const user = JSON.parse(localStorage.getItem('user'))
            const accessToken = user.token

            user.name = `${user.forename} ${user.surname}`
            user.nickname = user.forename
            user.locale = user.language

            // Fake some data to apease the JSON schema
            user.createdAt = new Date().toISOString()
            user.activatedAt = new Date().toISOString()
            user.isLegacy = true

            delete user.forename
            delete user.surname
            delete user.token
            delete user.password
            delete user.newPassword

            localStorage.setItem('user', JSON.stringify(user))
            localStorage.setItem('accessToken', JSON.stringify(accessToken))
        } catch (error) {
            sentry.err(error, {})
        }
    }

    if (oldVersion < 5) {
        // Remove language file
        try {
            localStorage.removeItem('language')
        } catch (error) {
            sentry.err(error, {})
        }
    }

    if (oldVersion < 6) {
        try {
            localStorage.removeItem('hasSSOAccessToken')
        } catch (error) {
            sentry.err(error, {})
        }
    }

    if (oldVersion < 7) {
        DS_setData('ShouldResyncToUpdateForms', () => ({ shouldResync: true }))
    }

    // Save the new version
    localStorage.setItem('lStorageVersion', LS_version.toString())
}
